import { render, staticRenderFns } from "./treeHole.vue?vue&type=template&id=01a61817&scoped=true&"
import script from "./treeHole.vue?vue&type=script&lang=js&"
export * from "./treeHole.vue?vue&type=script&lang=js&"
import style0 from "./treeHole.vue?vue&type=style&index=0&id=01a61817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a61817",
  null
  
)

export default component.exports